export const DISCLAIMER = `Your PFF subscription plan will be charged through your iTunes account. Your subscription automatically renews unless you turn it off in Account Settings 24+ hours before the end of the billing period. By joining, you agree to our`
export const OLD_HEADER_TEXT = 'AI POWERED TOOLS\nDATA TRUSTED BY ALL 32 NFL TEAMS'
export const OLD_STATEMENT_1 = 'Unlimited Fantasy League Sync'
export const OLD_STATEMENT_2 = 'Fantasy Start/Sit Line-Up Optimizer & Waiver Wire'
export const OLD_STATEMENT_3 = 'WR-CB & OL-DL Matchups, PFF Player Grades & Premium Stats 2.0 Tools'
export const OLD_STATEMENT_4 = 'Nathan Jahnkes Rankings - #1 Most Accurate Last 70 Weeks'
export const OLD_STATEMENT_5 = 'PFF Best Bets, Player Props, & Power Ranking Tools'

export const HEADER_TEXT = 'YOUR WINNING SEASON STARTS NOW'
export const SUBHEADER_TEXT = 'Unlock your edge. Get PFF+ today.'
export const TITLE_1 = 'Betting'
export const TITLE_2 = 'Fantasy'
export const TITLE_3 = 'Elite Football Intelligence'
export const TITLE_4 = 'Draft'
export const STATEMENT_1 =
  'Beat the books with real-time cover probabilities, sortable hit rates, alt-line sliders, matchup ratings and more.'
export const STATEMENT_2 =
  'Win drafts, weeks and leagues with the #1 fantasy mock draft sim, live draft assistance, weekly start/sit calls, waiver wire insights, and award-winning PFF rankings.'
export const STATEMENT_3 =
  'See beyond the box score with exclusive player grades, Premium Stats and expert analysis trusted by all 32 NFL teams.'
export const STATEMENT_4 =
  'Build your board with the top-ranked Mock Draft Simulator and the most accurate player data in football.'
export const CURRENCY = '$'
export const MONTHLY_TYPE = 'Monthly'
export const MONTHLY_DESCRIPTION = ''
export const MONTHLY_TEXT = 'Billed Monthly'
export const ANNUAL_HEADLINE = 'Best Deal'
export const ANNUAL_TYPE = 'Annual'
export const ANNUAL_DESCRIPTION = ''
export const ANNUAL_TEXT = 'Billed Yearly'
export const CONTINUE = 'Subscribe'
export const POLICY = 'privacy policy'
export const TERMS_OF_USE = 'terms of service'
export const SKIP = 'Skip'
export const FREE = 'Free'
